import React from 'react';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import DiffFieldLayout from './DiffFieldLayout';

const SelectDiffField = ({
  source,
  label,
  choices,
}: {
  source: string;
  label: string;
  choices: { id: string; name: string }[];
}) => {
  const record = useRecordContext();

  const oldValue = get(record, `${source}.oldRawValue`);
  const newValue = get(record, `${source}.newRawValue`);

  return (
    <DiffFieldLayout
      label={label}
      oldElement={(
        <SelectField
          record={{ value: oldValue }}
          source="value"
          choices={choices}
          emptyText="-"
        />
      )}
      newElement={(
        <SelectField
          record={{ value: newValue }}
          source="value"
          choices={choices}
          emptyText="-"
        />
      )}
    />
  );
};

export default SelectDiffField;
